import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { RotationPurposeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  RotationPurposeCreateDto,
  RotationPurposeDto,
  RotationPurposeExcelDownloadDto,
  RotationPurposeUpdateDto,
} from '../proxy/planning/dtos/rotation-purpose';
import { ROTATIONPURPOSE_CONFIG, ROTATIONPURPOSE_FIELDS } from './rotation-purpose.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-rotation-purpose',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, RotationPurposeService, ConfirmationService],
  templateUrl: './rotation-purpose.html',
  styleUrl: './rotation-purpose.scss',
})
export class RotationPurpose extends BaseCrudComponent<
  RotationPurposeDto,
  RotationPurposeCreateDto,
  RotationPurposeUpdateDto,
  RotationPurposeExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(RotationPurposeService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('RotationPurpose', ids),
  };
  config = ROTATIONPURPOSE_CONFIG;
  fields = ROTATIONPURPOSE_FIELDS;

  protected prepareUpdateDto(data: any, selected: RotationPurposeDto): RotationPurposeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'RotationPurpose';
  }
}
